import {charcoal} from '../sass/base/_exports.sass';

export const FontIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1, width = 12, height = 18} = props;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.03922 15V14.448C4.97522 14.448 4.66322 14.232 4.66322 13.2V7.824H6.79922C8.69522 7.824 8.81522 8.064 9.00722 9.552H9.43922V5.424H9.00722C8.81522 6.912 8.69522 7.176 6.79922 7.176H4.66322V1.128H6.89522C9.77522 1.128 10.6152 1.344 10.9512 4.056H11.3592L11.3112 0.456H0.583219V1.008C1.92722 1.008 2.45522 1.08 2.45522 2.232V13.224C2.45522 14.376 1.92722 14.448 0.583219 14.448V15H7.03922Z"
        fill={color}
      />
    </svg>
  );
};
